import { render, staticRenderFns } from "./TiposInstituicoes.vue?vue&type=template&id=35ac244e"
import script from "./TiposInstituicoes.vue?vue&type=script&lang=js"
export * from "./TiposInstituicoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports